"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__modelMeta__ = void 0;
var data_schema_types_1 = require("@aws-amplify/data-schema-types");
Object.defineProperty(exports, "__modelMeta__", { enumerable: true, get: function () { return data_schema_types_1.__modelMeta__; } });
